var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "c-accordion" },
    [
      _c("transition", { attrs: { name: "u-fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isOpen,
                expression: "isOpen",
              },
            ],
            staticClass: "c-accordion__content",
          },
          [_vm._t("default")],
          2
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "c-accordion__controls" }, [
        _c(
          "button",
          {
            staticClass: "c-accordion__button",
            class: [_vm.isOpen ? _vm.activeClass : "is-active"],
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleContent.apply(null, arguments)
              },
            },
          },
          [
            _c(
              "svg",
              {
                staticClass: "c-accordion__icon",
                class: [_vm.isOpen ? _vm.activeClass : "is-active"],
                attrs: { width: "40", height: "12" },
              },
              [
                _c("polyline", {
                  attrs: {
                    points: "12,2 20,10 28,2",
                    "stroke-width": "3",
                    fill: "none",
                  },
                }),
              ]
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }